import type { MarketVariants } from '@/lib/i18n'

export type Slide1InsightCopy = {
  /** Headline split around an italicised emphasis word. */
  headlineBefore: string
  headlineEmphasis: string
  body: string
}

export const copy: MarketVariants<Slide1InsightCopy> = {
  US: {
    headlineBefore: "Scammers don’t target intelligence, they target ",
    headlineEmphasis: 'emotions.',
    body:
      'Fear. Urgency. Love. Panic. These feelings have a major impact on how you process information and make decisions.',
  },
  ar: {
    headlineBefore: 'المحتالون لا يستهدفون ذكاءك، بل يستهدفون ',
    headlineEmphasis: 'مشاعرك.',
    body:
      'الخوف. الاستعجال. الحب. الذعر. هذه المشاعر تؤثر بشكل كبير في طريقة استيعابك للمعلومات واتخاذك للقرارات.',
  },
}
